var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg16PxAntenna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    width: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "antenna") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212121",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,14V7.723a2,2,0,1,0-2,0V14H5v2h6V14Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M4.25,9.308a5,5,0,0,1,0-6.616l1.5,1.325a3,3,0,0,0,0,3.966Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M2.285,11.6a8,8,0,0,1,0-11.2L3.714,1.8a6,6,0,0,0,0,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M11.75,9.308a5,5,0,0,0,0-6.616l-1.5,1.325a3,3,0,0,1,0,3.966Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M13.715,11.6a8,8,0,0,0,0-11.2L12.286,1.8a6,6,0,0,1,0,8.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16PxAntenna);
export default __webpack_public_path__ + "static/media/16px_antenna.980d80a5c64596a5dcc8b3c48325cb57.svg";
export { ForwardRef as ReactComponent };